var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 316 50.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#43b7c5;}.cls-2{fill:#482d7d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,34.26l-2.85-7.85a1.13,1.13,0,0,1,.31-1.24,5.28,5.28,0,1,0-7,0,1.13,1.13,0,0,1,.31,1.24l-2.85,7.85a.52.52,0,0,0,.49.7H25.52A.52.52,0,0,0,26,34.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.4,25.44A16.26,16.26,0,0,1,67.91,9.28,16.81,16.81,0,0,1,77.11,12a2.57,2.57,0,0,1-2.84,4.29,11.48,11.48,0,0,0-6.36-1.91A11.29,11.29,0,0,0,56.5,25.44,11.29,11.29,0,0,0,67.91,36.51a11.42,11.42,0,0,0,6.49-2,2.56,2.56,0,0,1,2.88,4.24A16.55,16.55,0,0,1,51.4,25.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.31,25.46a16.51,16.51,0,0,1,33,0,16.51,16.51,0,0,1-33,0Zm16.5,11.07a11.2,11.2,0,0,0,11.37-11.07,11.37,11.37,0,0,0-22.74,0A11.21,11.21,0,0,0,96.81,36.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.05,38.36a2.53,2.53,0,0,1,2.63-2.59H131c5.72,0,9.12-4.5,9.12-10.4,0-8.27-6.07-10.22-9.12-10.22H119.68a2.53,2.53,0,0,1-2.63-2.59A2.55,2.55,0,0,1,119.64,10H131c5.72,0,14.25,4,14.25,15.35,0,8.79-5.81,15.53-14.25,15.53H119.64A2.55,2.55,0,0,1,117.05,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151,38.36V12.56A2.55,2.55,0,0,1,153.54,10a2.59,2.59,0,0,1,2.59,2.54v25.8a2.59,2.59,0,0,1-2.59,2.54A2.55,2.55,0,0,1,151,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.13,38.28V12.66a2.61,2.61,0,0,1,1.7-2.46,2.53,2.53,0,0,1,2.88.68l18.84,20.57V12.66a2.65,2.65,0,0,1,5.3,0V38.28a2.62,2.62,0,0,1-1.7,2.46,2.73,2.73,0,0,1-2.93-.68l-18.79-20.7V38.28a2.65,2.65,0,0,1-5.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.73,25.46A16.41,16.41,0,0,1,212.24,9.25a16.76,16.76,0,0,1,9.2,2.76,2.54,2.54,0,0,1,.72,3.56,2.5,2.5,0,0,1-3.52.73,11.79,11.79,0,0,0-6.4-1.91,11.22,11.22,0,0,0-11.37,11.07,11.2,11.2,0,0,0,11.37,11.07,9.36,9.36,0,0,0,9.46-7.13h-7.17a2.55,2.55,0,1,1,0-5.09h10A2.54,2.54,0,0,1,227,26.77a14.39,14.39,0,0,1-14.8,14.9A16.39,16.39,0,0,1,195.73,25.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.77,38.36V12.61a2.57,2.57,0,1,1,5.14,0v12L252.77,10.7a2.63,2.63,0,0,1,3.48,3.94L244.54,24.91l11.8,11.45a2.67,2.67,0,0,1,.08,3.74,2.63,2.63,0,0,1-3.73,0L240.6,28.39l-3.69,3.22v6.75a2.57,2.57,0,0,1-5.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.73,10h19.94a2.57,2.57,0,0,1,0,5.13H262.78a2.57,2.57,0,1,1,0-5.13Zm-2.58,28.34V27a2.54,2.54,0,0,1,2.63-2.63h14.29a2.57,2.57,0,0,1,0,5.13H265.28v6.28h17.25a2.57,2.57,0,0,1,0,5.13h-19.8A2.55,2.55,0,0,1,260.15,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.45,38.34V26.46L288.63,14.29a2.56,2.56,0,0,1,3.82-3.4L302,21.63l9.55-10.74a2.55,2.55,0,1,1,3.81,3.4L304.54,26.46V38.34a2.55,2.55,0,1,1-5.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,48.29V2.63A2.54,2.54,0,0,1,2.63,0h8.44A2.65,2.65,0,0,1,13.7,2.63a2.65,2.65,0,0,1-2.63,2.63H5.26v40.4h5.81a2.63,2.63,0,0,1,0,5.26H2.63A2.54,2.54,0,0,1,0,48.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.43,48.29a2.65,2.65,0,0,1,2.63-2.63h5.81V5.26H29.06a2.65,2.65,0,0,1-2.63-2.63A2.65,2.65,0,0,1,29.06,0H37.5a2.54,2.54,0,0,1,2.64,2.63V48.29a2.54,2.54,0,0,1-2.64,2.63H29.06A2.65,2.65,0,0,1,26.43,48.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4be7824627233cca48eb40590291056b.svg";
export { ForwardRef as ReactComponent };